import React, { useRef, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Upload } from "lucide-react";

// Uploads one or more files via the authenticated admin endpoint.
// onUploaded receives an array of FileRef objects: {id,url,filename,content_type,visibility}
export default function FileUpload({
  visibility = "public",
  multiple = true,
  accept = "image/*",
  label = "Upload",
  category = "general",
  onUploaded,
  testId = "file-upload",
}) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    const out = [];
    for (const f of files) {
      const fd = new FormData();
      fd.append("file", f);
      fd.append("visibility", visibility);
      fd.append("category", category);
      try {
        const r = await api.post("/admin/upload", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        out.push(r.data);
      } catch (err) {
        toast.error("Upload failed: " + (err.response?.data?.detail || f.name));
      }
    }
    setBusy(false);
    if (out.length && onUploaded) onUploaded(out);
    if (ref.current) ref.current.value = "";
  };

  return (
    <div>
      <input
        ref={ref}
        type="file"
        accept={accept}
        multiple={multiple}
        className="hidden"
        onChange={handle}
        data-testid={`${testId}-input`}
      />
      <Button
        type="button"
        variant="outline"
        disabled={busy}
        onClick={() => ref.current?.click()}
        data-testid={`${testId}-btn`}
      >
        <Upload size={15} className="mr-2" />
        {busy ? "Uploading…" : label}
      </Button>
    </div>
  );
}
